import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Box, AppBar, Toolbar, Button } from '@mui/material';
import GamesList from './pages/GamesList';  // We'll move the current content here
import UrlForm from './pages/UrlForm';

function App() {
  return (
    <Router>
      <Box>
        <AppBar position="static">
          <Toolbar>
            <Button color="inherit" component={Link} to="/">
              Games
            </Button>
            <Button color="inherit" component={Link} to="/add">
              Add URL
            </Button>
          </Toolbar>
        </AppBar>

        <Routes>
          <Route path="/" element={<GamesList />} />
          <Route path="/add" element={<UrlForm />} />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;
